import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { remarkWikilinks } from '../editor/Preview';
import { useOpenLink } from '../../hooks/useOpenLink';

/** Assistant text: GFM + [[wikilinks]] that open notes, external links in a new tab. */
export function AgentMarkdown({ text }: { text: string }) {
  const openLink = useOpenLink();
  return (
    <div className="agent-md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkWikilinks]}
        components={{
          a: ({ href, children, className, ...rest }) => {
            if (href?.startsWith('wikilink:')) {
              const target = decodeURIComponent(href.slice('wikilink:'.length));
              return (
                <a {...rest} className="wikilink" href={`#/note/${encodeURIComponent(target)}`} title={target} onClick={(e) => (e.preventDefault(), void openLink(target, { split: e.ctrlKey || e.metaKey }))}>
                  {children}
                </a>
              );
            }
            return (
              <a {...rest} className={className as string} href={href} target="_blank" rel="noreferrer noopener">
                {children}
              </a>
            );
          },
        }}
      >
        {text.replace(/^Spoken:\s*.+$/m, '').trimEnd()}
      </ReactMarkdown>
    </div>
  );
}
